var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportToExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 0a.653.653 0 0 0-.654.652c0 .36.293.651.654.651h11.136a.653.653 0 0 0 .654-.651.653.653 0 0 0-.654-.652H2.4z",
    fill: "#85B440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.62c0-.64-.521-1.159-1.164-1.159H1.164A1.17 1.17 0 0 0 0 3.631V14.84C0 15.482.522 16 1.165 16h13.67C15.48 16 16 15.481 16 14.842V3.62zM3.86 10.123l.586 1.03h.918L4.372 9.58l.986-1.542h-.903L3.9 9.074h-.052l-.554-1.036h-.951l.988 1.576-.98 1.538h.875l.583-1.03h.05zm2.129 1.026h.826V6.845H5.99v4.304zm1.616-2.206c0 .478.296.764.904.897l.568.127c.275.062.395.159.395.317 0 .206-.222.348-.543.348-.33 0-.531-.127-.594-.342h-.807c.057.588.557.924 1.384.924.82 0 1.38-.401 1.38-1.018 0-.464-.272-.718-.88-.851l-.588-.127c-.29-.065-.423-.164-.423-.323 0-.203.218-.342.514-.342.307 0 .497.127.54.334h.764c-.046-.588-.514-.92-1.31-.92-.781 0-1.304.394-1.304.976zm4.546 1.18.585 1.03h.917l-.991-1.573.986-1.542h-.904l-.554 1.036h-.05l-.555-1.036h-.952l.99 1.576-.981 1.538h.875l.582-1.03h.052z",
    fill: "#85B440"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportToExcel);
export default __webpack_public_path__ + "static/media/export-to-excel.9f38c3961fde6f4fabcfc909c8b57a10.svg";
export { ForwardRef as ReactComponent };